var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 523,
    viewBox: "0 0 1440 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V387.5L0 522.5V0Z",
    fill: "#E0F7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle1);
export default __webpack_public_path__ + "static/media/rectangle-1.7ded79a68de2af39b2af48eca3cbbf88.svg";
export { ForwardRef as ReactComponent };